import { configureStore } from "@reduxjs/toolkit";
import counterReducer from "./Slices/counter";

export default configureStore({
  reducer: {
    counter: counterReducer,
  },
});
